import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const reportG8 = {
    getDataReport,
    getFixDataReport,
    getServiceProp,
    getForecast
};

function getDataReport(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG8/getDataReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getFixDataReport(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG8/getMobileAvgFixed/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getServiceProp(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG8/getServiceProp/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getForecast(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG8/getForecast/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}